import React from 'react';
import GeoMapEditor from '../../components/admin/geogusser/GeoMapEditor';

/**
 * Per-key migration wizard for `geoguesser.map_needs_floor_review`.
 *
 * Renders the full GeoMapEditor (map details + floors + levels) and
 * adds a migration-specific footer that calls `onSubmit({})` to
 * clear the deprecation flag when the admin is happy.
 *
 * All editing behaviour (auto-save, draft persistence, drag-and-
 * drop, re-pin picker) lives in the shared component set under
 * `components/admin/geogusser/` so the admin edit flow and any
 * future surfaces can share the same UI.
 */
const AdminGeoMapMigrationWizard = ({ detail, onSubmit, submitting }) => {
  const mapPk = detail?.pk;
  if (!mapPk) return null;

  return (
    <GeoMapEditor
      mapId={mapPk}
      title="Confirm map floor layout"
      enableLevelDraft
      footer={() => (
        <footer className="map-migration-footer">
          <p>
            Once you&apos;re done reassigning levels, confirm the
            migration to clear the deprecation flag on this map.
          </p>
          <button
            type="button"
            className="btn-primary"
            disabled={submitting}
            onClick={(e) => {
              e.preventDefault();
              onSubmit({});
            }}
          >
            {submitting ? 'Finalising…' : 'Mark migration complete'}
          </button>
        </footer>
      )}
    />
  );
};

export default AdminGeoMapMigrationWizard;
